<template>
  <div class="profile">
    <div class="profileHead" style="">
      <div class="slider" :class="{ 'move-right': mode === 'history' }"></div>
      <p class="profileSelector profileSelected" @click="changeMode">{{ $t("profile") }}</p>
      <p class="profileSelector" @click="changeMode">{{ $t("history") }}</p>
    </div>
    <TransitionGroup name="fade">
      <div class="profileInfo" v-if="mode === 'profile'">
        <div class="userBlock">
          <p style="font-size: 36px">{{ user.emoji }}</p>
          <div class="userBlockText">
            <div class="userLogin">
              <p style="font-weight: 700; font-size: 18px; margin-right: 5px">{{ user.login }}</p>
              <img v-if="user.verification" src="../assets/verification.svg" />
            </div>
            <div class="idBlock">
              <p style="font-size: 16px">
                id: <span style="color: #727272">{{ user.numId }}</span>
              </p>
              <img src="../assets/copy.svg" @click="copyID" />
            </div>
          </div>
        </div>
        <div class="profileBlock">
          <p>{{ $t("verifyStatus") }}</p>
          <p v-if="user.verification" style="font-weight: 700; color: #007bff">{{ $t("success") }}</p>
          <p v-else style="font-weight: 700; color: #ff3b30">{{ $t("notSuccess") }}</p>
        </div>
        <div class="profileBlock">
          <p>{{ $t("totalTrades") }}</p>
          <p>{{ win + lose }}</p>
        </div>
        <div class="profileBlock">
          <p>{{ $t("successTrades") }}</p>
          <p>{{ win }}</p>
        </div>
        <div class="profileBlock">
          <p>{{ $t("lossTrades") }}</p>
          <p>{{ lose }}</p>
        </div>
        <div class="profileBlock languageBlock" style="flex-direction: row; justify-content: space-between; cursor: pointer" @click="showLanguage" @mouseenter="isShowLanguage = true" @mouseleave="isShowLanguage = false">
          <Transition name="fade">
            <div class="selectLanguage" style="cursor: default" v-if="isShowLanguage">
              <div class="languageComponent" id="ru" @click="selectLanguage">
                <div class="languageInfo">
                  <img src="../assets/logo/ru.svg" />
                  <p>Русский</p>
                </div>
                <img class="galka" src="../assets/galka.svg" v-if="this.$store.getters.getLanguage == 'ru'" />
              </div>
              <div class="languageComponent" id="en" @click="selectLanguage">
                <div class="languageInfo">
                  <img src="../assets/logo/en.svg" />
                  <p>English</p>
                </div>
                <img class="galka" src="../assets/galka.svg" v-if="this.$store.getters.getLanguage == 'en'" />
              </div>
            </div>
          </Transition>
          <div style="display: flex; align-items: center; gap: 7px">
            <img src="../assets/logo/ru.svg" width="25" v-if="this.$store.state.language == 'ru'" />
            <img src="../assets/logo/en.svg" width="25" v-else />
            <p style="font-size: 16px; font-weight: 400; color: white">{{ $t("language") }}</p>
          </div>
          <img src="../assets/arrow-down-no-line.svg" width="20" class="arrowDown" :class="isShowLanguage ? 'activated' : null" />
        </div>
        <div class="logoutButton" @click="hideLogout">
          <p>{{ $t("signOut") }}</p>
          <img src="../assets/logoutDoor.svg" />
        </div>
        <div class="logoutFull" @click="hideLogout" v-if="logout">
          <div class="logoutArea">
            <p>{{ $t("sureSignOut") }}</p>
            <div class="logoutButtons">
              <div class="acceptLogout" @click="acceptLogout">Да</div>
              <div class="cancelLogout">Нет</div>
            </div>
          </div>
        </div>
      </div>
      <div class="historyInfo" v-if="mode == 'history'">
        <div class="betHistory">
          <p class="nullBets" v-if="betHistory.length == 0">Пока что здесь пусто, сделайте первую сделку</p>
          <div class="betCardInfo" v-else v-for="bet in betHistory" v-bind:key="bet">
            <p class="betCardDate">{{ bet.date }}</p>
            <div class="betCard" v-for="b in bet.bets" v-bind:key="b">
              <div class="betInformation">
                <div class="betHead">
                  <div class="betHistoryDot">
                    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#eba02a">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z"
                          stroke="#eba02a"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                    </svg>
                    <p class="betHeadText">{{ b.currencyCode }}</p>
                  </div>
                  <p class="betHeadText">{{ new Date(b.timestamp).toTimeString().split(":")[0] + ":" + new Date(b.timestamp).toTimeString().split(":")[1] }}</p>
                </div>
                <div class="betSummary">
                  <p class="betSummaryText">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="b.bet == 'up' ? 'transform: rotate(-45deg);' : 'transform: rotate(45deg)'">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier"><path d="M6 12H18M18 12L13 7M18 12L13 17" :stroke="b.bet == 'up' ? '#00c896' : '#ed3232'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                    </svg>
                    {{ b.amount }}₽
                  </p>
                  <p class="betSummaryText" style="justify-self: center" :style="b.outcome == 'WIN' ? 'color: #00C896;' : 'color: #FF3B30;'">{{ b.outcome == "WIN" ? "+" + b.amount + "₽" : "-" + b.amount + "₽" }}</p>
                  <p class="betSummaryText" :class="b.outcome == 'WIN' ? 'betSummaryTextWin' : 'betSummaryTextLose'" style="justify-self: right">{{ b.outcome == "WIN" ? b.amount * b.multiplier : 0 }}₽</p>
                </div>
              </div>
            </div>
          </div>
          <button class="showMore" @click="showMoreHistory" v-if="isShowMore && betHistory.length > 0">Показать еще</button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
  import axios from "axios"
  import { nextTick } from "vue"
  import { useI18n } from "vue-i18n"
  import { useToast } from "vue-toastification"
  export default {
    name: "ProfileComponent",
    data() {
      return {
        active: "profile",
        user: { _id: "356kgkgkgkgkgkgk" },
        win: " ",
        lose: " ",
        logout: false,
        mode: "profile",
        betHistory: [],
        betPage: 0,
        betPageCount: 2,
        isShowMore: true,
        isShowLanguage: false,
        lang: this.$store.state.language,
      }
    },
    setup() {
      const toast = useToast()
      const { locale } = useI18n()
      return { toast, locale }
    },
    methods: {
      getStats() {
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/bet/stats`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.user.token,
            },
          })
          .then((res) => {
            this.win = res.data.result.win
            this.lose = res.data.result.lose
          })
      },
      hideLogout() {
        if (this.logout) this.logout = false
        else this.logout = true
      },
      acceptLogout() {
        this.toast.success("Вы успешно вышли", { timeout: 2000 })
        window.location.href = "/"
        this.$store.commit("logout")
      },
      copyID() {
        navigator.clipboard.writeText(this.user.numId)
        this.toast.success("Ваш ID успешно скопирован!", { timeout: 2000 })
      },
      selectLanguage(event) {
        let id = event.target.closest(".languageComponent").id
        this.$store.commit("setLanguage", id)
        this.lang = id
        this.locale = id
        window.$chatwoot.setLocale(id)
        console.log(id)
      },
      async changeMode() {
        let el = document.querySelectorAll(".profileHead p")
        if (this.mode == "profile") {
          this.mode = "history"
          el[0].className = "profileSelector"
          el[1].classList.add("profileSelected")
          await nextTick()
          this.checkIsBet()
        } else {
          this.mode = "profile"
          el[1].className = "profileSelector"
          el[0].classList.add("profileSelected")
        }
      },
      getBetHistory() {
        const formatDate = (timestamp) => {
          const date = new Date(timestamp)
          const day = String(date.getDate()).padStart(2, "0")
          const month = String(date.getMonth() + 1).padStart(2, "0") // Месяцы от 0 до 11
          const year = date.getFullYear()
          return `${day}.${month}.${year}`
        }
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/bet/history`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.user.token,
            },
            params: {
              offset: this.betPage * 25,
              count: 25,
            },
          })
          .then((res) => {
            this.betPageCount = Math.ceil(res.data.result.total / 25)
            let groupedData = res.data.result.data.reduce((acc, item) => {
              const date = formatDate(item.timestamp)
              let dateGroup = acc.find((group) => group.date === date)
              if (!dateGroup) {
                dateGroup = { date, bets: [] }
                acc.push(dateGroup)
              }
              dateGroup.bets.push(item)
              return acc
            }, [])
            for (let j of groupedData) {
              this.betHistory.push(j)
            }
            // this.betHistory = groupedData
            // console.log(this.betHistory)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      async showMoreHistory(event) {
        let el = event.target.closest("button")
        el.classList.add("disabled")
        this.betPage += 1
        this.getBetHistory()
        setTimeout(() => {
          el.className = "showMore"
          if (this.betPage + 1 == this.betPageCount) this.isShowMore = false
        }, 500)
      },
      checkIsBet() {
        if (this.$store.getters.getIsBet) {
          let el = document.querySelectorAll(".betCardInfo")
          el = el[0]
          el = el.querySelectorAll(".betCard")[0]
          el.style.backgroundColor = "#0033AD80"
          let text = el.querySelectorAll(".betSummaryText")[1]
          text.innerText = "В процессе"
          text.style.color = "#FFFFFF"
          let text1 = el.querySelectorAll(".betSummaryText")[2]
          text1.innerText = ""
        }
      },
    },
    watch: {
      isBetState(newValue) {
        if (!newValue) {
          let el = document.querySelectorAll(".betCardInfo")
          el = el[0]
          el = el.querySelectorAll(".betCard")[0]
          el.style.backgroundColor = "#0b0b0b"
          let text = el.querySelectorAll(".betSummaryText")[1]
          let text1 = el.querySelectorAll(".betSummaryText")[2]
          console.log(this.betHistory[0].bets[0])
          if (this.betHistory[0].bets[0].outcome == "WIN") {
            text.innerText = "+" + this.betHistory[0].bets[0].amount + "₽"
            text.style.color = "#00C896"
            text1.innerText = this.betHistory[0].bets[0].amount * this.betHistory[0].bets[0].multiplier + "₽"
            text1.style.color = "#00C896"
          } else {
            text.innerText = "-" + this.betHistory[0].bets[0].amount + "₽"
            text1.innerText = "0₽"
            text1.style.color = "#FF3B30"
            text.style.color = "#FF3B30"
          }
        }
      },
    },
    computed: {
      isBetState() {
        return this.$store.getters.getIsBet
      },
    },
    mounted() {
      this.user = this.$store.getters.getUserData
      this.getStats()
      this.getBetHistory()
      // document.addEventListener('click', this.handleClickOutsideLanguage);
    },
    // beforeUnmount() {
    //   document.removeEventListener('click', this.handleClickOutsideLanguage);
    // }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .profile {
    height: 100vh;
    width: 20vw;
    background: black;
    /* position: absolute; */
    border-left: 1px solid rgba(77, 77, 77, 0.452);
    border-right: 1px solid rgba(77, 77, 77, 0.452);
    /* left:6%; */
    text-align: left;
    padding: 20px;

    overflow-y: scroll;
    overflow: overlay;
    overflow-x: hidden;
    scrollbar-gutter: stable;
    scrollbar-color: #ffffff #000000;
    scrollbar-width: thin;
    position: relative;
  }
  .userBlock {
    border-radius: 10px;
    background-color: #141414;
    border: 1px solid #ffffff0d;
    padding: 25px;
    display: flex;
    align-items: center;
    margin-bottom: 5%;
  }
  .selectLanguage {
    position: absolute;
    bottom: 100%;
    right: 0;
    background-color: rgb(40, 40, 40);
    border: 1px solid #ffffff0d;
    padding: 15px;
    width: 80%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .languageComponent {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
  .languageInfo {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .languageInfo p {
    color: white !important;
  }
  .galka {
    width: 3vh;
  }
  .arrowDown {
    display: flex;
    transition: all 0.5s;
  }
  .arrowDown.activated {
    transform: rotate(180deg);
    transform-origin: center center;
    transition: all 0.5s;
  }
  .profileBlock {
    border-radius: 10px;
    background-color: #141414;
    border: 1px solid #ffffff0d;
    padding: 25px;
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
    position: relative;
  }
  .profileHead {
    background-color: #0b0b0b;
    border-radius: 53px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    padding: 3px;
    margin-bottom: 5%;
    margin-top: 3%;
    position: relative;
  }
  .profileSelector {
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 3%;
    padding-bottom: 3%;
    color: #5f5f5f;
    font-size: 1vw;
    font-weight: 700;
    cursor: pointer;
    user-select: none;
    z-index: 2;
    transition: color 0.8s;
  }
  .slider {
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: 0.3vw;
    width: 50%;
    background-color: #151515;
    border-radius: 55px;
    transition: transform 0.5s ease, width 0.8s;
    z-index: 1; /* За текстом */
  }
  .slider.move-right {
    transform: translateX(92%);
  }
  .profileSelected {
    color: #ffffff;
    /* background-color: #151515; */
    border-radius: 55px;
  }
  .betInfo {
  }
  .betHistory {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: all 0.6s ease;
  }
  .nullBets {
    font-size: 18px;
    color: #ffffffb2;
  }
  .betCardInfo {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .betCardDate {
    text-align: center;
    color: #ffffffb2;
  }
  .betCard {
    background-color: #0b0b0b;
    border-radius: 10px;
    display: flex;
    gap: 10px;
    padding: 5% 10% 5% 10%;
    border: 1px solid #3a3a3a66;
  }
  .betInformation {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  .betHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .betHistoryDot {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .betHeadText {
    font-size: 14px;
    font-weight: 400;
    color: #ffffffb2;
  }
  .betSummary {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .betSummaryText {
    font-weight: 700;
    color: #ffffff;
    display: flex;
    gap: 5px;
    align-items: center;
  }
  .betSummaryTextWin {
    color: #00c896;
  }
  .betSummaryTextLose {
    color: #ff3b30;
  }
  .profileBlock p:nth-child(1) {
    font-size: 18px;
  }
  .profileBlock p:nth-child(2) {
    font-weight: 700;
    color: #5f5f5f;
    font-size: 16px;
  }
  .userLogin {
    display: flex;
    align-items: center;
    margin-bottom: 1px;
  }
  .userBlockText {
    margin-left: 10px;
  }
  .logoutButton {
    display: none;
  }
  .logoutFull {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logoutArea {
    border-radius: 10px;
    background-color: #0f0f0f;
    padding: 3%;
    width: 80%;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-weight: 700;
    text-align: center;
    padding: 40px;
  }
  .logoutArea p {
    font-size: 18px;
  }
  .logoutButtons {
    display: grid;
    margin-top: 20px;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
  }
  .acceptLogout {
    background-color: #000000;
    border-radius: 8px;
    padding: 16px 14px 16px 14px;
    cursor: pointer;
    text-align: center;
  }
  .cancelLogout {
    background-color: #007bff;
    border-radius: 8px;
    padding: 16px 14px 16px 14px;
    cursor: pointer;
    text-align: center;
  }
  .showMore {
    border-radius: 10px;
    font-weight: 600;
    font-size: 16px;
    padding: 10px;
    width: 80%;
    border: 1px solid transparent;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3s;
  }
  .showMore:hover {
    filter: drop-shadow(0 0 6px white);
    transition: 0.3s;
  }
  .showMore.disabled {
    background-color: #7d7d7d;
  }
  .idBlock {
    display: flex;
    gap: 7px;
    align-items: center;
  }
  .idBlock img {
    background-color: transparent;
    cursor: pointer;
    width: 18px;
  }
  .fade-move,
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  }

  /* 2. declare enter from and leave to state */
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: scaleY(0.5) translate(30px, 0);
  }

  /* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
  .fade-leave-active {
    position: absolute;
  }

  @media (max-width: 968px) {
    .profile {
      width: 100%;
      background-image: url("../assets/backgroundMobile.png");
      background-position: 0 50vh;
      background-size: 200%;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      z-index: 8;
    }
    .profileHead {
      font-size: 24px;
    }
    .profileBlock {
      margin-bottom: 3%;
      padding: 5%;
    }
    .userBlock {
      margin-bottom: 3%;
    }
    .logoutButton {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-color: #ff3b3026;
      border-radius: 8px;
      padding: 16px;
      gap: 5px;
      font-size: 16px;
      font-weight: 700;
      border: 1px solid #ffffff0d;
    }
    .betHistory {
      max-height: 75vh;
    }
    .profileSelector {
      font-size: 18px;
    }
  }
  @media (max-height: 700px) {
    .profileBlock p:nth-child(1) {
      font-size: 16px;
    }
    .profileBlock p:nth-child(2) {
      font-weight: 700;
      color: #5f5f5f;
      font-size: 14px;
    }
    .userBlock {
      padding: 18px 25px 18px 25px;
    }
    .betHistory {
      max-height: 70vh;
    }
  }
</style>
